import { styled } from "styled-components";
/* у контейнера всегда должна быть какая-то ширина. Контейнер призван ограничить контент по ширине и центрировать его. Если не получается померить контейнер то бери 1140-1170 пикселей.*/
export const Container = styled.div`
max-width: 1170;
width: 100%;
min-height: 100%;
padding: 0 15px;
margin: 0 auto;
/* outline: 1px solid red; */
`